import { Box } from "@chakra-ui/react";
import { Helmet } from "react-helmet";
import { useEffect } from "react";
import DemoBanner from "../components/DemoBanner/DemoBanner";
import ShotShowHeroSection from "../components/ShotShowSections/ShotShowHeroSection";
import ShotShowWhoIsForSection from "../components/ShotShowSections/ShotShowWhoIsForSection";
import ShotShowHowItWorksSection from "../components/ShotShowSections/ShotShowHowItWorksSection";
import ShotShowDemoSection from "../components/ShotShowSections/ShotShowDemoSection";
import ShotShowFormSection from "../components/ShotShowSections/ShotShowFormSection";
import ShotShowFooter from "../components/ShotShowSections/ShotShowFooter";


const ShotShowPage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <Box position={"relative"} top={{ base: "", xl: "30px" }} mb={"60px"}>
      <Helmet>
        <title>SHOT Show 2026 | Partner with BulletScout</title>
        <meta
          name="description"
          content="SHOT Show creates interest—BulletScout drives traffic. Partner with the premier ammo search engine to connect with high-intent buyers."
        />
      </Helmet>

      <DemoBanner />
      <ShotShowHeroSection />
      <ShotShowWhoIsForSection />
      <ShotShowHowItWorksSection />
      <ShotShowDemoSection />
      <ShotShowFormSection />
      <ShotShowFooter />
    </Box>
  );
};

export default ShotShowPage;
